import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/SubstancesTR/';

export default {
  getSubstanceTRList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveSubstanceTR: data => post(`${defaultUrl}`, data),
};
